import type { MetaFunction } from '@remix-run/node';
import type { loader as professionalsLoader } from '~/routes/_app.professionals.$';
import type { loader as professionalsLoaderRocco } from '~/routes/_app.rocco.professionals.$';
import type { ListItem, PostalAddress } from 'schema-dts';
import { getMetaBaseUrl } from '../util/create-meta-base-url';
import type { StaticParentLoaders } from '../util';
import { createPostalAddress } from './professional-schema';
import type { LibraryLocation } from '~/modules/search';

export const createProfessionalsItemListSchema: MetaFunction<
    typeof professionalsLoader | typeof professionalsLoaderRocco,
    StaticParentLoaders
> = (props) => {
    const { data, location } = props;
    if (!data) {
        return [];
    }
    const baseUrl = getMetaBaseUrl(props);
    const itemListElement: ListItem[] =
        data.searchResult?.hits?.map((prof, idx) => {
            const locations: LibraryLocation[] =
                prof.SearchLocations?.filter(
                    (location) => location.LocationType !== 'ServiceArea'
                ) ?? [];

            if (!locations.length) {
                locations.push({
                    Country: prof.Country,
                });
            }

            let mainLocation = locations.find(
                (location) => location.LocationType === 'Head Office'
            );

            // if there's no head office, pick the first non service area location
            if (!mainLocation) {
                mainLocation = locations.filter(
                    (location) => !!location.LocationType
                )[0];
            }

            const selectedAddress: PostalAddress[] = locations.map((loc) => {
                return createPostalAddress(loc, prof.Country);
            });

            return {
                '@type': 'ListItem',
                position: data.pagination?.currentRange?.from + idx,
                item: {
                    '@type': 'LocalBusiness',
                    name: prof.Title ?? '',
                    logo: baseUrl + prof.CompanyLogos?.Thumb_sm,
                    image: baseUrl + prof.Thumb_lg,
                    url: baseUrl + prof.Link,
                    address: selectedAddress,
                    ...(mainLocation?.MapCoordinates && {
                        geo: {
                            '@type': 'GeoCoordinates',
                            latitude: mainLocation?.MapCoordinates?.Latitude,
                            longitude: mainLocation?.MapCoordinates?.Longitude,
                        },
                    }),
                },
            };
        }) ?? [];
    return [
        {
            '@type': 'ItemList',
            url: baseUrl + location.pathname,
            numberOfItems: data.searchResult?.nbHits ?? 0,
            itemListElement,
        },
    ];
};
